.missingEvent {
  color: #999;
  font-size: 11px;
  font-style: italic;
}
